import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as LocationIcon } from "../rsc/ic_location.svg";
import { ReactComponent as PhoneIcon } from "../rsc/ic_phone.svg";
import { SwitchLang } from "./SwitchLang";
import { colorDark } from "../rsc/colors/colors";

const { version } = require('../../package.json')

type FooterPempemProps = {
    style?: React.CSSProperties
}

export function FooterPempem({style}: FooterPempemProps) {

    const {t, i18n } = useTranslation();

    const changeLanguage = (value) => {
        dayjs.locale(value)
        i18n.changeLanguage(value)
    }

    const infoLinkStyles = "font-[300] text-center text-[white] px-[20px] py-[5px] hover:border-[white] hover:border-[2px] border-[2px] border-[transparent] cursor-pointer w-[100%]"

    // Footer height 
    return (<div style={{...style, background: "#1a2535"}} className="py-[20px] px-[30px] place-content-around flex flex-wrap max-lg:min-w-full max-md:flex-col max-md:gap-[30px]">
        {/* <div className="flex flex-col gap-[30px] max-md:pl-[20px]">
            <p className="text-[white]">{version}</p>
        </div>
        <div className="flex flex-col w-[fit-content]">
            <a href="https://www.pempem.io/about-us" className={infoLinkStyles}>{t('about_us')}</a>
            <a href="https://www.pempem.io/product" className={infoLinkStyles}>{t('product')}</a>
            <a href="https://www.pempem.io/" className={infoLinkStyles}>{t('blog')}</a>
            <a href="https://www.pempem.io/news" className={infoLinkStyles}>{t('news')}</a>
            <a href="https://www.pempem.io/contact" className={infoLinkStyles}>{t('contact')}</a>
        </div>
        <div className="flex flex-col gap-[10px]">
            <div className="flex items-center gap-[10px]">
                <LocationIcon fill="white" />
                <p className="text-[white] font-[600]">Montreal Office</p>
            </div>
            <p className="text-[white] pl-[22px]">1435 St Alexander St Suite 300</p>
            <p className="text-[white] pl-[22px]">Montreal, QC H3A 2G4 Canada</p>
        </div>
        <div className="flex flex-col gap-[16px]">
            <div className="flex flex-col gap-[10px]">
                <div className="flex items-center gap-[10px]">
                    <LocationIcon fill="white" />
                    <p className="text-[white] font-[600]">Indonesia Office – Pekanbaru</p>
                </div>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Meetup Coworking Space Pekanbaru</p>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Jl. Todak No. 18, Tengkerang Bar.,</p>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Kec. Marpoyan Damai,</p>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Kota Pekanbaru, Riau 28124</p>
            </div>
            <div className="flex flex-col gap-[10px]">
                <div className="flex items-center gap-[10px]">
                    <LocationIcon fill="white" />
                    <p className="text-[white] font-[600]">Indonesia Office – Jakarta</p>
                </div>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Millennium Centennial Center, 39th floor,</p>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Jl. Jend. Sudirman Kav. 25,</p>
                <p className="text-[white] pl-[22px] w-[240px] leading-[20px]">Jakarta 12920</p>
            </div>
        </div> */}
        {/* Full-width legal / Pengaduan Konsumen row */}
        <div className="w-[100%] flex flex-row flex-wrap gap-[60px] max-md:gap-[30px] justify-end max-md:justify-center">
            <div className="flex flex-col gap-[6px] max-md:w-[170px]">
                <p className="text-[white] font-[700] text-[14px]">Pengaduan Konsumen</p>
                <p className="text-[white] text-[13px]">Layanan Pengaduan Konsumen</p>
                <p className="text-[white] text-[13px]">PT. Pemasok Mitra Pembeli Dua</p>
                <a href="mailto:care@pempem.io" className="text-[white] text-[13px] underline hover:opacity-80">care@pempem.org</a>
                <div className="flex items-center gap-[6px]">
                    <PhoneIcon fill="white" width={13} height={13} />
                    <a href="tel:0817890036" className="text-[white] text-[13px] underline hover:opacity-80">0817890036</a>
                </div>
            </div>
            <div className="flex flex-col gap-[6px] w-[250px] max-md:w-[170px]">
                <span className="text-[white] text-[13px] font-[500] bold" >Direktorat Jenderal Perlindungan</span>
                <span className="text-[white] text-[13px] font-[500] bold" >Konsumen dan Tertib Niaga</span>
                <p className="text-[white] text-[13px]">Kementerian Perdagangan Republik Indonesia</p>
                <div className="flex items-center gap-[6px]">
                    <PhoneIcon fill="white" width={13} height={13} />
                    <a href="tel:0817890036" className="text-[white] text-[13px] underline hover:opacity-80">085311111010</a>
                </div>
            </div>
        </div>
    </div>)
}